/* @flow */

import { SessionStore } from "../uidispatcherapi/SessionStore";
import * as util from "./util";
import urlTemplateLib from "url-template";
import { default as moment } from "moment";

import { REQUEST_PRIORITY } from "./PriorityUtil";

const exported = {
    buildPath(pathParts: Array<any>): string {
        return (Object.values(pathParts ?? [])).map((part) => {
                return encodeURIComponent(part);
            })
            .join("/");
    },

    getTimestampForQueryAsObject() {
        return { __t: moment().valueOf() };
    },

    buildQuery(query: { [x: string]: any }): string {
        return Object.keys(query ?? {})
            .map((key) => {
                const value = query[key];
                if (value === undefined || value === null) {
                    return null;
                }
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        return null;
                    }
                    return value.map((item) => {
                        if (item) {
                            return key + "=" + encodeURIComponent(item);
                        } else {
                            return "";
                        }
                    }).join("&");
                }
                return key + "=" + encodeURIComponent(value);
            })
            .filter((entry) => entry !== null)
            .join("&");
    },

    buildRequest(
        vertical: string,
        service: string,
        newRoute: boolean,
        version: string | undefined | null,
        template: string,
        pathParams: {
            [x: string]: string | number;
        },
        queryParams:
            | {
                  [x: string]: any;
              }
            | undefined
            | null
    ) {
        let baseUrl = "".concat("/", vertical, ".", service);
        if (version && version.length > 0) {
            baseUrl = baseUrl.concat(".", version);
        }
        if (newRoute) baseUrl = "".concat("/", vertical, "/", service);
        const relativePath = urlTemplateLib.parse(template).expand(pathParams);
        const preQuery = queryParams && exported.buildQuery(queryParams);
        const query = preQuery ? "?" + preQuery : "";
        return "".concat(baseUrl, relativePath, query);
    },

    /**
     * Tries to get the CallTreeId and client session id from the SessionStore.
     * Otherwise generates its own.
     */
    generateSessionedUuid(): string {
        if (SessionStore.generateSessionedCallTreeIdWithPrefix) {
            return SessionStore.generateSessionedCallTreeIdWithPrefix("BTEX");
        } else {
            return "BTEX-" + util.generateUuid();
        }
    },

    makeCallTreeHeader(): {
        [x: string]: string;
    } {
        return { CallTreeId: exported.generateSessionedUuid() };
    },

    makeCallTreeHeaderWithPriority(priority: REQUEST_PRIORITY): {
        [x: string]: string;
    } {
        return Object.assign({}, exported.makeCallTreeHeader(), exported.makePriorityHeader(priority));
    },

    makePriorityHeader(priority: REQUEST_PRIORITY): {
        [x: string]: string;
    } {
        return { "x-qos-priority": priority };
    }
};

export default exported;

export const {
    buildPath,
    getTimestampForQueryAsObject,
    buildQuery,
    buildRequest,
    generateSessionedUuid,
    makeCallTreeHeader,
    makeCallTreeHeaderWithPriority,
    makePriorityHeader
} = exported;
